import {
  PROJECT_SCENARIO_COMPARE_REQUEST,
  PROJECT_SCENARIO_COMPARE_SUCCESS,
  PROJECT_SCENARIO_COMPARE_ERROR,
  PROJECT_SCENARIO_COMPARE_RESET,
} from "./projectScenarioCompareActionTypes";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function projectScenarioCompareReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case PROJECT_SCENARIO_COMPARE_REQUEST:
      return { ...state, loading: true, error: null };
    case PROJECT_SCENARIO_COMPARE_SUCCESS:
      return { data: payload, loading: false, error: null };
    case PROJECT_SCENARIO_COMPARE_ERROR:
      return { ...state, loading: false, error: payload };
    case PROJECT_SCENARIO_COMPARE_RESET:
      return initialState;
    default:
      return state;
  }
}
